<template>
  <div>
    <div v-if="isPc" class="banner_swipe">
      <div id="box" ref="box">
        <div class="marquee-box" ref="marquee" @mouseover="menter" @mouseleave="mleave">
          <p ref="cmdlist" id="pWidth">
            <img src="../assets/images/notice.png" />
          <ul>
            <li class="little_hand" v-for="(item, index) in newsList" :key="index"
              @click="fnToArticle(item.article_id)">
              <a class="list-circle" :href="item.url">{{ item.title }}</a>
            </li>
          </ul>
          </p>
        </div>
      </div>
      <div class="banner">
        <el-main>
          <div class="container">
            <div class="banner-left">
              <vue-typed-js class="desc" :strings="typingTexts" :cursorChar="'_'">
                <span class="typing"></span>
              </vue-typed-js>
              <vue-typed-js class="desc" :strings="typingTexts2" :cursorChar="''" startDelay="700">
                <span class="typing"></span>
              </vue-typed-js>
            </div>
            <div class="swiper-right">
              <!-- 轮播banner -->
              <el-carousel :autoplay="false" arrow="never" height="384px" class="swipe_right little_hand">
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                  <div class="swipe_item" @click="swipeToColumns(item)">
                    <el-image :src="$imgUrl + item.image_url" fit="cover"></el-image>
                    <div class="desc_info" v-if="item.model_type == 6">
                      <h4>{{ item.title }}</h4>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>

        </el-main>
      </div>

    </div>
    <div v-if="isPc" class="bg-grey">
      <div class="search-con-box">
        <el-main>
          <div class="search-con">
            <h2>我們為您提供了 <b>{{ cunpanNum }}+</b> 份政策文件供您查閱</h2>
            <el-input placeholder="請輸入關鍵字" v-model="title" clearable>
              <el-button slot="append" icon="el-icon-search" @click="fnToSearch"></el-button>
            </el-input>
            <div class="hot-search">
              <div class="hot-con">
                <h4>猜妳要找：</h4>
                <span class="little_hand" v-for="item in hotTag" :key="item.id" @click="toSearch(item.type_name)">{{
                  item.type_name }}</span>
              </div>
              <div class="more little_hand" @click="fnToPolicy(3)">查看更多 <i class="el-icon-arrow-right"></i> </div>
            </div>
          </div>
          <div class="chats ">
            <!-- <div class="chats-info">
              <div id="echartContainer" style="width:735px; height:424px"></div>
              <div class="total-num">
                <h3>企业总数 <b class="little_hand" @click="fnToCompanyMemberList(0)">742+</b></h3>
                <h3>会员总数 <b class="little_hand" @click="fnToCompanyMemberList(1)">{{memberNum}}+</b></h3>
                <h3>涉及行业 <b>1,200+</b></h3>
              </div>
            </div> -->
            <div class="column-title">
              <h3>協會會員</h3>
              <div class="more little_hand" @click="fnToCompanyMemberList(1)">查看更多 <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <p>
              協會成立以來，不斷致力於提高工作效率，提升工作質量，開拓創新，積極奮進。1998年，協會率先引入ISO9002國際質量認證體系，2015年又成立了「深圳台商協會義工隊」，成功開創國內台協導入ISO9002國際質量認證體系及成立義工組織的先河；協會先後為海峽兩岸的公益事業捐贈逾兩億人民幣。目前協會緊密聯繫著全市3000多家台資企業和在深居住的5萬多名台胞，截止至2022年，會員人數3015人。
            </p>
            <div class="member-num">
              <div class="member-num-item" v-for="item in memberListNum" :key="item.area"
                @click="fnToCompanyMemberList(1, item.area, item.child.length)">
                <h4>{{ item.area }}</h4>
                <span>{{ item.total }}</span>
                <div class="member-num-child" v-if="item.child.length > 0">
                  <ul>
                    <li :class="{ 'two-column': item.child.length > 7 }" v-for="it in item.child" :key="it.area"
                      @click.stop="fnToCompanyMemberList(1, it.area, 0)">{{ it.area }}{{ it.num }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </div>
      <el-main>
        <div class="events">
          <div class="title justify-between align-center">
            <h3>{{ eventsRes.title }}</h3>
            <div class="more little_hand" @click="fnToInformation(5)">查看更多 <i class="el-icon-arrow-right"></i> </div>
          </div>
          <p class="desc">{{ eventsRes.desctext }}</p>
          <swiper v-if="eventsRes.title" :id="eventsRes.id" />
        </div>
      </el-main>
      <el-main>

        <div class="section-news">
          <div class="section-left">
            <div class="news">
              <div class="column-title">
                <h3>協會動態</h3>
                <div class="more little_hand" @click="fnToInformation(0)">查看更多 <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="news-dynamic">
                <div class="news-dynamic-left little_hand" v-if="newsList.length > 0"
                  @click="fnToArticle(newsList[0].article_id)">
                  <el-image :src="newsList[0].main_image[0]" fit="cover"></el-image>
                  <h3>
                    <p>{{ newsList[0].title }}</p>
                  </h3>
                </div>
                <div class="news-dynamic-right">
                  <div class="news-dynamic-item little_hand" v-for="(item, index) in newsList.slice(1, 6)" :key="index"
                    @click="fnToArticle(item.article_id)">
                    <div class="title">
                      <h3>{{ item.title }}</h3>
                      <div>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</div>
                    </div>
                    <div class="line" v-if="index != 4"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="news">
              <div class="column-title">
                <h3>专项服务</h3>
                <div class="more little_hand" @click="fnToPolicy(2)">查看更多 <i class="el-icon-arrow-right"></i> </div>
              </div>
              <div class="news-service">
                <div class="news-service-item little_hand" v-for="(item, index) in serviceList.slice(0, 4)" :key="index"
                  @click="fnToArticle(item.article_id)">
                  <h3>{{ item.title }}</h3>
                  <span :style="'background-color:' + item.color">{{ item.type }}</span>
                  <time>{{ $dayjs(item.create_time).format("YYYY-MM-DD") }}</time>
                </div>
              </div>
            </div>
            <div class="news">
              <div class="column-title">
                <h3>汇课堂</h3>
                <div class="more little_hand" @click="fnToPolicy(1)">查看更多 <i class="el-icon-arrow-right"></i> </div>
              </div>
              <div class="news-class">
                <div class="news-class-item little_hand" v-for="(item, index) in courseList" :key="index"
                  @click="fnToCourse(item.course_id)">
                  <img :src="$imgUrl + item.main_image" alt="">
                  <h3>{{ item.course_name }}</h3>
                  <time>{{ $dayjs(item.create_time).format("YYYY-MM-DD") }}</time>
                </div>
              </div>
            </div>
          </div>
          <div class=" section-right">
            <!-- 杂志 -->
            <el-carousel :autoplay="false" arrow="never" height="482px" class="swipe_left little_hand">
              <el-carousel-item v-for="(item, index) in magazineList" :key="index" :label="index + 1">
                <el-image :src="$imgUrl + item.main_image" fit="cover" @click="toOutSideUrl(item.file_url)"></el-image>
                <p>{{ item.title }}</p>
              </el-carousel-item>
            </el-carousel>
            <div class="news news-story">
              <div class="column-title">
                <h3>台商故事</h3>
                <div class="more little_hand" @click="fnToInformation(3)">查看更多 <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="news-story-list">
                <div class="news-story-list-item little_hand" v-for="(item, index) in storyList.slice(0, 5)"
                  :key="index" @click="fnToArticle(item.article_id)">
                  <div class="story-title">{{ item.title }}</div>
                  <div class="line" v-if="index != 4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fix_btn">
          <el-popover placement="left" width="100" trigger="hover" popper-class="wx_popper" v-if="infoRes.wxQrcode">
            <!-- <el-image
              style="width: 100px; height: 100px"
              :src="$imgUrl +infoRes.wxQrcode"
              fit="cover"></el-image> -->

            <img :src="$imgUrl + infoRes.wxQrcode" style="width: 100px; height: 100px" alt="" />
            <div class="btn_wx" slot="reference"><em></em></div>
          </el-popover>
          <el-popover placement="left" width="100" trigger="hover" popper-class="wx_popper">
            <div class="sz_qcode">
              <img src="../assets/images/i_shenzhen.png" alt="" />
            </div>
            <div class="btn_sz" slot="reference"><em></em></div>
          </el-popover>
          <el-popover placement="left" width="100" trigger="hover" popper-class="wx_popper">
            <el-image style="width: 100px; height: 100px" :src="require('../assets/images/tsh_qcode.png')"
              fit="cover"></el-image>
            <div class="btn_tsh" slot="reference"><em></em></div>
          </el-popover>
          <el-popover placement="left" width="100" trigger="hover" popper-class="wx_popper">
            <el-image style="width: 100px; height: 100px" :src="require('../assets/images/shenitai_qcode.png')"
              fit="cover"></el-image>
            <div class="btn_tsh btn_shenitai" slot="reference"><em></em></div>
          </el-popover>
          <!-- <div class="btn_wx"><em></em></div> -->
          <el-popover placement="left" width="120" trigger="hover" popper-class="wx_popper">
            <div>{{ infoRes.phone }}</div>
            <div class="btn_tel" slot="reference"><em></em></div>
          </el-popover>
          <el-popover placement="left" width="120" trigger="hover" popper-class="wx_popper">
            <div class="little_hand" @click="applyForAdmission">加入協會</div>
            <div class="btn_join" slot="reference"><em></em></div>
          </el-popover>
          <!-- <div class="btn_tel"><em></em></div> -->
          <div class="btn_top" @click="backTop"><em></em></div>
        </div>
        <div class="publicity">

        </div>
        <!-- 弹框 -->
      </el-main>
    </div>

    <div v-else>
      <div class="m-logo">
        <router-link :to="{ path: '/' }">
          <img :src="$imgUrl + $store.state.logo" />
          <span>深圳台商協會</span>
        </router-link>
      </div>
      <div class="m-title">
        <vue-typed-js class="desc" :strings="typingTexts" :cursorChar="'_'">
          <span class="typing"></span>
        </vue-typed-js>
        <vue-typed-js class="desc" :strings="typingTexts2" :cursorChar="''" startDelay="700">
          <span class="typing"></span>
        </vue-typed-js>
      </div>
      <div class="m-swiper">
        <el-carousel :autoplay="false" arrow="never" height="230px" class="swipe_right little_hand" ref="carousel">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <v-touch :swipe-options="{ direction: 'horizontal' }" @swipeleft="swiperleft(index)"
              @swiperight="swiperright(index)" class="wrapper">
              <div class="swipe_item" @click="swipeToColumns(item)">
                <el-image :src="$imgUrl + item.image_url" fit="cover"></el-image>
                <div class="desc_info" v-if="item.model_type == 6">
                  <h4>{{ item.title }}</h4>
                </div>
              </div>
            </v-touch>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="column-menu">
        <el-row>
          <el-col :span="6" v-for="(item, index) in mobileMenu" :key="index">
            <router-link v-if="index != 1" :to="{ path: `${item.path}` }">
              <div class="grid-content">
                <img :src="item.img" />
                <span>{{ item.name }}</span>
              </div>
            </router-link>
            <a v-else :href="item.path">
              <div class="grid-content">
                <img :src="item.img" />
                <span>{{ item.name }}</span>
              </div>
            </a>
          </el-col>
        </el-row>
      </div>
      <div class="newsList">
        <div class="newsList-title">
          <h3>協會動態</h3>
          <div class="column_title_more" @click="fnToInformation(0)">查看更多 <i class="el-icon-arrow-right"></i></div>
        </div>
        <ul>
          <li v-for="(item, index) in newsList" :key="index" class="news_item" @click="fnToArticle(item.article_id)">
            <el-image :src="item.main_image[0]" fit="cover"></el-image>
            <div class="news_item_info">
              <h3>{{ item.title }}</h3>
              <div class="news_item_time">
                <div>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</div>
                <!-- <div class="el-icon-view">{{ item.times }}</div> -->
              </div>
              <!-- <div class="news_item_desc" v-if="item.desctext">
                {{ item.desctext }}
              </div> -->
            </div>
          </li>
        </ul>
        <el-button type="info" @click="fnToInformation(0)">點擊加載更多</el-button>
        <div class="link" v-if="$store.state.linkList.length > 0">
          <h5>友情鏈接：</h5>
          <ul>
            <li v-for="(item, index) in $store.state.linkList" :key="index">
              <!-- <el-image
                :src="$imgUrl + item.image"
                fit="cover"
                @click="toOutSideUrl(`${item.url}`)"
              ></el-image> -->
              <span @click="toOutSideUrl(`${item.url}`)">{{ item.name }}</span>
            </li>
            <div class="clear"></div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import analyze from "rgbaster";
//引入地图数据
import sz from "@/assets/js/sz.json";
var echarts = require("echarts");
import Vue from "vue";
import VueTypedJs from "vue-typed-js";

Vue.use(VueTypedJs);
import swiper from "./common/swiper.vue";

export default {
  components: {
    swiper,
  },
  data() {
    return {
      eventsRes: {},
      typingTexts: ["<h1>智慧台協</h1> "],
      typingTexts2: ["<h2>連接兩岸 溝通政府 服務台商</h2>"],
      memberListNum: [
        {
          area: "原特區內會員",
          total: "450",
          child: [
            {
              area: "羅湖",
              num: "：150",
            },
            {
              area: "福田",
              num: "：150",
            },
            {
              area: "南山",
              num: "：150",
            },
          ],
        },
        {
          area: "西片區會員",
          total: "1050",
          child: [
            {
              area: "新安",
              num: "：120",
            },
            {
              area: "西鄉",
              num: "：80",
            },
            {
              area: "福永.福海",
              num: "：60",
            },
            {
              area: "沙井.新橋",
              num: "：200",
            },
            {
              area: "松崗.燕羅",
              num: "：150",
            },
            {
              area: "光明",
              num: "：150",
            },
            {
              area: "石岩",
              num: "：45",
            },
            {
              area: "龍華",
              num: "：200",
            },
            {
              area: "觀瀾",
              num: "：45",
            },
          ],
        },
        {
          area: "東片區會員",
          total: "465",
          child: [
            {
              area: "布吉",
              num: "：100",
            },
            {
              area: "平湖",
              num: "：50",
            },
            {
              area: "龍崗.龍城",
              num: "：80",
            },
            {
              area: "橫崗",
              num: "：50",
            },
            {
              area: "坪地",
              num: "：80",
            },
            {
              area: "坪山",
              num: "：60",
            },
            {
              area: "大鵬",
              num: "：45",
            },
          ],
        },
        {
          area: "青委會",
          total: "850",
          child: [],
        },
        {
          area: "婦委會",
          total: "200",
          child: [],
        },
      ],
      scrollTop: "",
      //获取列表参数
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 2,
      },
      start: 0,
      limit: 4,
      article_type: "",
      adListRes: [],
      fileListRes1: [],
      fileListRes2: [],
      courseList: [], //汇课堂
      serviceListRes: [],
      firstXHDT: {},
      activeName: "0",
      magazineList: [],
      bannerList: [],
      newsList: [],
      companyList: [],
      value: 0,
      timer: "", //计时器
      pwidth: 0, //公告文本的宽度
      windowWidth: document.documentElement.clientWidth, // 设备屏幕的宽度
      title: "",
      fileTypeList: [],
      hotTag: [],
      storyList: [],
      companyNum: 0,
      memberNum: 0,
      cunpanNum: 0,
      totalNumsArr: [
        {
          name: "鹽田",
          value: "0",
          company_value: 0,
        },
        {
          name: "羅湖",
          value: "13",
          company_value: 73,
        },
        {
          name: "福田",
          value: "45",
          company_value: 35,
        },
        {
          name: "南山",
          value: "120",
          company_value: 76,
        },
        {
          name: "寶安",
          value: "0",
          company_value: 266,
          child: [
            {
              name: "松崗",
              value: "1",
              company_value: 66,
            },
            {
              name: "沙井",
              value: "115",
              company_value: 85,
            },
            {
              name: "福永",
              value: "30",
              company_value: 27,
            },
            {
              name: "西鄉",
              value: "42",
              company_value: 32,
            },
            {
              name: "新安",
              value: "33",
              company_value: 26,
            },
            {
              name: "石岩",
              value: "33",
              company_value: 30,
            },
          ],
        },
        {
          name: "龍崗",
          value: "190",
          company_value: 108,
          child: [
            {
              name: "龍崗",
              value: "18",
              company_value: 18,
            },
            {
              name: "布吉",
              value: "72",
              company_value: 42,
            },
            {
              name: "平湖",
              value: "43",
              company_value: 19,
            },
            {
              name: "橫崗",
              value: "13",
              company_value: 14,
            },
            {
              name: "坪地",
              value: "44",
              company_value: 15,
            },
          ],
        },
        {
          name: "大鵬新區",
          value: "0",
          company_value: 1,
        },
        {
          name: "龍華",
          value: "91",
          company_value: 75,
          child: [
            {
              name: "龍華",
              value: "59",
              company_value: 46,
            },
            {
              name: "觀瀾",
              value: "32",
              company_value: 29,
            },
          ],
        },
        {
          name: "坪山",
          value: "23",
          company_value: 22,
        },
        {
          name: "光明",
          value: "94",
          company_value: 61,
        },
      ],
      investListRes: [],
      length: 0,
      active: 0,
      mobileMenu: [
        {
          name: "登錄",
          path: "/login",
          type: "/login",
          img: require("../assets/images/association01.png"),
        },
        {
          name: "實習報名",
          path: "https://intern.upapi.cn/portal/#/",
          type: "https://intern.upapi.cn/portal/#/",
          img: require("../assets/images/association015.png"),
        },
        {
          name: "資訊",
          path: "/information/0",
          type: "/information",
          img: require("../assets/images/association02.png"),
        },
        // {
        //   name: "抗疫助企",
        //   path: "/information/2",
        //   type: "/information/2",
        //   img: require("../assets/images/association03.png"),
        // },
        {
          name: "電子雜誌",
          path: "/magazine",
          type: "/magazine",
          img: require("../assets/images/association04.png"),
        },
        {
          name: "企業會員",
          path: "/company_member_list/1",
          type: "/company_member_list",
          img: require("../assets/images/association05.png"),
        },
        {
          name: "協會公告",
          path: "/policy/0",
          type: "/policy",
          img: require("../assets/images/association06.png"),
        },
        {
          name: "匯課堂",
          path: "/policy/1",
          type: "/policy",
          img: require("../assets/images/association07.png"),
        },
        {
          name: "專項服務",
          path: "/policy/2",
          type: "/policy",
          img: require("../assets/images/association08.png"),
        },
        {
          name: "采購需求",
          path: "/Invest",
          type: "/Invest",
          img: require("../assets/images/association09.png"),
        },
        {
          name: "政策文件",
          path: "/policy/3",
          type: "/policy",
          img: require("../assets/images/association010.png"),
        },
        {
          name: "關於協會",
          path: "/introduce",
          type: "/introduce",
          img: require("../assets/images/association011.png"),
        },
        {
          name: "指南",
          path: "/guide",
          type: "/guide",
          img: require("../assets/images/association012.png"),
        },
        {
          name: "繳費",
          path: "/fee",
          type: "/fee",
          img: require("../assets/images/association013.png"),
        },
        {
          name: "個人中心",
          path: "/person_center",
          type: "/person_center",
          img: require("../assets/images/association014.png"),
        },
      ],
    };
  },
  computed: {
    ...mapState([
      "isPc",
      "infoRes",
      "rowMenuList",
      "headerMenuList",
      // "mobileMenu",
      "user_id",
      "validToken",
    ]),
    // mobileMenu(){
    //   let menuRes=this.headerMenuList;
    //   console.log(menuRes)
    //   menuRes[0]={
    //     name:'登錄',
    //     url:'/login'
    //   }
    //   menuRes.push({
    //     name:'個人中心',
    //     url:'/person_center'
    //   })
    //   return menuRes
    // },
    serviceList() {
      return this.serviceListRes.map((item) => {
        if (item.article_type == "QTFW") {
          item.type = "健康";
          item.color = "#1AC659";
        } else if (item.article_type == "ZXXX") {
          item.type = "企管";
          item.color = "#0279FF";
        } else if (item.article_type == "CASE") {
          item.type = "法律";
          item.color = "#C076DB";
        } else if (item.article_type == "CWZX") {
          item.type = "財稅";
          item.color = "#FF3A30";
        } else if (item.article_type == "PPWZ") {
          item.type = "品牌";
          item.color = "#FFCB02";
        } else if (item.article_type == "FYWZ") {
          item.type = "防疫";
          item.color = "#51AAF2";
        } else {
          item.type = "";
        }
        return item;
      });
    },
  },

  watch: {
    $route(to, from) {
      if (to.name != "/") {
        this.$notify.closeAll();
      } else {
        this.open();
      }
    },
    rowMenuList(val, old) {
      if (val) {
        this.getNewsList("XHDT");
      }
    },
    value(newValue, oldValue) {
      let allWidth = parseInt(this.windowWidth) + parseInt(this.pwidth[0]);
      if (newValue <= -allWidth) {
        this.$refs.cmdlist.style.marginLeft = this.windowWidth + "px";
        this.value = 0;
      }
    },
  },
  created() {
    let locale = sessionStorage.getItem("language") || "";
    let temp = locale === "s" ? "t" : "s";
    if (temp == "s") {
      this.typingTexts = ["<h1>智慧台協</h1> "];
      this.typingTexts2 = ["<h2>連接兩岸 溝通政府 服務台商</h2>"];
    } else {
      this.typingTexts = ["<h1>智慧台协</h1> "];
      this.typingTexts2 = ["<h2>连接两岸 沟通政府 服务台商</h2>"];
    }
    this.$store.dispatch("getProfile");
    this.getFileList(2); //公告
    this.getSlideList(); //轮播
    this.getFileTypeList(); //政策文件类型
    this.getServiceList(); //专项服务
    this.getCourseList(); //汇课堂
    this.getMagazineList(); //杂志
    this.getNewsList("XHDT"); //协会动态
    this.getNewsList("MJSX"); //台商故事
    this.getEvents(); //大事记
    // this.getCompanyList();
    // this.getAdList();
    //政策文件
    // this.getFileList(1);
    if (this.isPc) {
      this.getStatistics(); //获取协会统计数据
    }
    // this.getInvestList();
  },
  updated() { },
  mounted() {
    if (this.isPc) {
      window.addEventListener("scroll", this.scrollToTop);
      let element = this.$refs.cmdlist;
      this.pwidth = document.defaultView
        .getComputedStyle(element, "")
        .width.split("px");
      this.timer = setInterval(this.clickCommend, 20);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    clearInterval(this.timer);
  },
  methods: {
    filterTableMater(name, arr, val) {
      for (const item of arr) {
        if (item.child && item.child.length) {
          let sum = 0;
          for (const child of item.child) {
            if (child.name == name) {
              child.value = val;
            }
            sum += Number(child.value);
          }
          item.value = sum;
        } else {
          if (item.name === name) {
            item.value = val;
          }
        }
      }
    },
    fnToSearch() {
      if (!this.title) return false;
      this.$router.push({
        path: `/policy/3?keyword=${this.title}`,
      });
    },
    toSearch(type_name) {
      this.$router.push({
        path: `/policy/3?keyword=${type_name}`,
      });
    },
    open() {
      let vm = this;
      this.$notify({
        title: "",
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 0,
        message: `<img src="${this.$imgUrl + this.investListRes[this.active].main_image
          }" />`,
        onClick: function () {
          vm.$router.push({
            path: `/investInfo/${vm.investListRes[vm.active].info_id}`,
          });
          // this.close()
        },
      });
    },
    //項目投資列表
    async getInvestList() {
      const { data: res } = await this.$http.get("/api/v2/investInfo/list", {
        params: {
          type: "invest",
          association_id: "SZTX",
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.investListRes = res.data;
      this.getOrderList();
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    async getOrderList() {
      const { data: res } = await this.$http.get("/api/v2/investInfo/list", {
        params: {
          type: "order",
          association_id: "SZTX",
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.investListRes = [...this.investListRes, ...res.data];
      this.length = this.investListRes.length;
      this.active = Math.floor(Math.random() * this.length);
      if (this.length > 0) {
        this.open();
        setTimeout(() => {
          this.$zhTran();
        }, 300);
      }
    },
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("echartContainer"));
      echarts.registerMap("深圳", sz);
      let vm = this;
      // 绘制图表
      myChart.setOption({
        tooltip: {
          className: "pop-item",
          formatter: function (params) {
            var htmlStr = "<div>";
            htmlStr += "<h3>" + params.name + "</h3>";
            // htmlStr +=
            //   "企業：" +
            //   (params.data.company_value ? params.data.company_value : 0) +
            //   "<br/>";
            htmlStr += "會員：" + params.value + "<br/>";
            return htmlStr;
          },
          padding: 10,
          borderWidth: 0,
          extraCssText: "box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.1);",
        },
        visualMap: {
          show: false,
          min: 1,
          max: 350,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          opacity: 0,
          inRange: {
            color: [
              "rgba(32, 49, 127,.06)",
              "rgba(32, 49, 127,.07)",
              "rgba(32, 49, 127,.09)",
              "rgba(32, 49, 127,.16)",
              "rgba(32, 49, 127,.2)",
              "rgba(32, 49, 127,.25)",
              "rgba(32, 49, 127,.26)",
              "rgba(32, 49, 127,.28)",
              "rgba(32, 49, 127,.28)",
              "rgba(32, 49, 127,.3)",
              "rgba(32, 49, 127,.36)",
            ],
          },
        },
        series: [
          {
            name: "深圳市地图",
            type: "map",
            mapType: "深圳", // 自定义扩展图表类型，和上文注册名字的一样
            selectedMode: "single",
            itemStyle: {
              borderWidth: 0,
              borderColor: "#f00",
              normal: {
                borderWidth: 0,
                //正常状态
                label: {
                  show: true,
                  formatter: "{b}", //地图上显示的数据，分别对应data中的name和value
                  color: "#20317F",
                },
                areaColor: "rgba(32, 49, 127,.6)", //地图区域的颜色
              },
              emphasis: {
                //  鼠标移入高亮状态
                label: {
                  show: true,
                },
                areaColor: "#FF9500",
              },
              select: {
                //  鼠标移入高亮状态
                label: {
                  show: true,
                },
                itemStyle: {
                  areaColor: "#FF9500",
                  borderColor: "#000",
                },
              },
            },
            aspectScale: 0.9, //用于 scale 地图的长宽比
            zoom: 1.2,
            // top: "60",
            label: {
              show: false,
              position: [100, 10],
            },
            data: vm.totalNumsArr,
            // data: [
            //   {
            //     name: "羅湖",
            //     value: "8",
            //     dataIndex: 0,
            //   },
            //   {
            //     name: "福田",
            //     value: "9",
            //     num: "90",
            //     dataIndex: 1,
            //   },
            //   {
            //     name: "南山",
            //     value: "10",
            //     num: "100",
            //     dataIndex: 2,
            //   },
            //   {
            //     name: "寶安",
            //     value: "1",
            //     num: "10",
            //     dataIndex: 3,
            //   },
            //   {
            //     name: "龍崗",
            //     value: "2",
            //     num: "20",
            //     dataIndex: 4,
            //   },
            //   {
            //     name: "大鵬新區",
            //     value: "3",
            //     num: "30",
            //     dataIndex: 5,
            //   },
            //   {
            //     name: "鹽田",
            //     value: "4",
            //     num: "40",
            //     dataIndex: 6,
            //   },
            //   {
            //     name: "龍華",
            //     value: "5",
            //     num: "50",
            //     dataIndex: 7,
            //   },
            //   {
            //     name: "坪山",
            //     value: "7",
            //     num: "70",
            //     dataIndex: 8,
            //   },
            //   {
            //     name: "光明",
            //     value: "6",
            //     num: "60",
            //     dataIndex: 9,
            //   },
            // ],
          },
        ],
      });
      myChart.on("click", function (param) {
        vm.$router.push({
          path: `/company_member_list/0?area=${param.name}`,
        });
      });
    },
    // 获取协会统计数据
    async getStatistics() {
      const { data: res } = await this.$http.get(
        `/api/v2/association/statistics?association_id=SZTX`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      // this.totalNumsArr = [...this.totalNumsArr, ...res.data.memberCount];
      // console.log(res.data.memberCount);
      for (let i = 0; i < res.data.memberCount.length; i++) {
        this.filterTableMater(
          res.data.memberCount[i].name,
          this.totalNumsArr,
          res.data.memberCount[i].value
        );
      }
      // console.log(this.totalNumsArr);

      this.companyNum = res.data.companyNum;
      this.memberNum = res.data.memberNum;
      this.cunpanNum = res.data.cunpanNum;
      // console.log(this.totalNumsArr);

      // this.initCharts();
    },
    //设置滑动切换轮播图
    swiperleft: function (index) {
      //上一页
      this.$refs.carousel.prev();
      //设置幻灯片的索引
      this.$refs.carousel.setActiveItem(index + 1);
    },
    swiperright: function (index) {
      //下一页
      this.$refs.carousel.next();
      this.$refs.carousel.setActiveItem(index - 1);
    },
    // 获取杂志轮播列表
    async getMagazineList(context) {
      const { data: res } = await this.$http.get(
        `/api/v2/magazine/list?association_id=SZTX`
      );
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.magazineList = res.data.slice(0, 3).map((item) => {
        item.file_url = !/^http/.test(item.file_url)
          ? this.$imgUrl + item.file_url
          : item.file_url;
        return item;
      });
    },
    // 获取首页轮播列表
    async getSlideList() {
      const { data: res } = await this.$http.get(`/api/v2/slideshow/list`, {
        params: {
          searchJson: {
            slideshow_from: 1,
            association_id: "SZTX",
          },
        },
      });
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.bannerList = res.data.slice(0, 5).map((item, index) => {
        this.getColor(this.$imgUrl + item.image_url, index);
        return item;
      });
    },
    async getColor(image_url, index) {
      const result = await analyze(
        image_url,
        { scale: 0.01 },
        { ignore: ["rgb(255,255,255)", "rgb(0,0,0)"] }
      );
      if (result) {
        // console.log(result.color);
        this.bannerList[index].color = result[0].color;
      }
      return result;
    },
    // 点击 轮播图 跳转不同页面
    swipeToColumns(listItem) {
      // console.log(listItem)
      let model_type = listItem.model_type;
      let model_id = listItem.model_id;
      //1.活动详情,2.企业产品详情,3.企业详情,4.专题页,5.协会详情,6.文章详情,7.专家详情,8.投票,9.广告详情,10.视频详情,11.商城产品详情,12.跳转外部链接,13.直播,14.问卷
      if (model_type == 1) {
        this.$router.push({
          path: `/article/${model_id}`,
        });
      } else if (model_type == 2) {
        this.$router.push({
          path: `/product_details/${model_id}`,
        });
      } else if (model_type == 3) {
        this.fnToCompany(model_id);
      } else if (model_type == 4) {
        let topicUrl = `https://api2.ts960.com/test_theme_page/html/theme_details.html?topic_id=${model_id}`;
        this.toOutSideUrl(topicUrl);
      } else if (model_type == 6 || model_type == 10) {
        this.fnToArticle(model_id);
      } else if (model_type == 9) {
      } else if (model_type == 12) {
        this.toOutSideUrl(listItem.outside_url);
      }
    },
    async getNewsList(article_type) {
      let searchJson = {
        article_type: article_type,
      };
      if (article_type == "XHDT") {
        searchJson.association_id = "SZTX";
      }
      const { data: res } = await this.$http.get("/api/v2/article/list", {
        params: {
          start: 0,
          limit: 6,
          searchJson: searchJson,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);

      if (article_type == "XHDT") {
        this.newsList = res.data.map((item) => {
          item.main_image = JSON.parse(item.main_image);
          item.main_image = item.main_image.map((img) =>
            !/^http/.test(img) ? this.$imgUrl + img : img
          );
          return item;
        });
        this.firstXHDT = this.newsList[0];
      } else if (article_type == "MJSX") {
        this.storyList = res.data;
      }
    },
    fnToArticle(article_id) {
      // // console.log(article_id)
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
    fnToInformation(th) {
      this.$router.push({
        path: `/information/${th ? th : 0}`,
      });
    },
    async getFileList(type_id) {
      const { data: res } = await this.$http.get("/api/v2/cunpan/list", {
        params: {
          start: this.start,
          limit: type_id == 1 ? this.limit : 6,
          searchJson: {
            type: type_id,
            association_id: "SZTX",
          },
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      if (type_id == 1) {
        this.fileListRes1 = res.data;
      } else {
        this.fileListRes2 = res.data;
      }
    },
    //汇课堂
    async getCourseList() {
      const { data: res } = await this.$http.get("/api/v2/course/list", {
        params: {
          start: 0,
          limit: 3,
          user_id: this.user_id,
          searchJson: {},
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.courseList = res.data;
    },
    fnToCourse(course_id) {
      this.$router.push({
        path: `/course/${course_id}`,
      });
    },
    //服务文章
    async getServiceList() {
      const { data: res } = await this.$http.get("/api/v2/article/list", {
        params: {
          start: 0,
          limit: 4,
          searchJson: {
            article_type: "service",
            // association_id: "SZTX",
          },
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.serviceListRes = res.data;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    fnToFileDetails(cunpan_id) {
      this.$router.push({
        path: `/file/${cunpan_id}`,
      });
    },
    fnToPolicy(active) {
      this.$router.push({
        path: `/policy/${active}`,
      });
    },
    // 获取推荐企业列表
    async getCompanyList() {
      const { data: res } = await this.$http.get(`/api/v2/company/list`, {
        params: {
          start: this.start,
          limit: this.limit,
          searchJson: {
            association_id: "SZTX",
          },
        },
      });
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.companyList = res.data;
    },
    fnToCompany(company_id) {
      this.$router.push({
        path: `/company/${company_id}`,
      });
    },
    fnToCompanyMemberList(type, ass_area, child) {
      if (child > 0) {
        return false;
      }
      if (ass_area) {
        this.$router.push({
          path: `/company_member_list/${type}?ass_area=${ass_area}`,
        });
      } else {
        this.$router.push({
          path: `/company_member_list/${type}`,
        });
      }
    },

    fnToMyCompany() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.$router.push({
          path: `/my_company`,
        });
      }
    },
    // 获取广告列表
    async getAdList() {
      const { data: res } = await this.$http.get(`/api/v2/ad/list`);
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.adListRes = res.data.map((item) => ({
        adPic: !/^http/.test(JSON.parse(item.main_image))
          ? this.$imgUrl + JSON.parse(item.main_image)
          : JSON.parse(item.main_image),
        ad_id: item.ad_id,
      }));
    },
    toOutSideUrl(file_url) {
      // console.log(file_url);
      window.open(file_url, "_blank");
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 0) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    clickCommend(e) {
      let _this = this;
      this.$nextTick(() => {
        this.value -= 1;
        this.$refs.cmdlist.style.marginLeft =
          _this.windowWidth + this.value + "px";
      });
    },
    menter() {
      clearInterval(this.timer);
    },
    mleave() {
      this.timer = setInterval(this.clickCommend, 20);
    },
    async getFileTypeList() {
      const { data: res } = await this.$http.get("/api/v2/cunpan/prolicyType");
      if (res.code !== "200") return false;
      this.fileTypeList = res.data;
      this.hotTag = this.fileTypeList.slice(0, 6);
    },
    applyForAdmission() {
      this.$router.push({
        path: `/apply`,
      });
    },
    // 获取大事记列表
    async getEvents() {
      const { data: res } = await this.$http.get(
        `/api/v2/article/timeMemoryList/SZTX`
      );
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.eventsRes = res.data[0];
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-popover {
  min-width: 100px !important;
}

.sz_qcode img {
  width: 100%;
}

.fix_btn {
  position: fixed;
  top: 50%;
  right: 27px;
  z-index: 99;

  div {
    cursor: pointer;
    width: 48px;
    height: 48px;
    box-shadow: 0px 2px 7px 0px rgba(213, 213, 213, 0.75);
    border-radius: 60px;
    margin-bottom: 10px;
    background-color: #fff;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  em {
    width: 22px;
    height: 22px;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .btn_sz em {
    background-image: url("../assets/images/i_shenzhen_logo.png");
  }

  .btn_tsh em {
    background-image: url("../assets/images/tsh_logo.jpg");
  }

  .btn_shenitai em {
    background-image: url("../assets/images/shenitai_logo.png");
  }

  .btn_wx em {
    background-image: url("../assets/images/wx.png");
  }

  .btn_tel em {
    background-image: url("../assets/images/tel.png");
  }

  .btn_top em {
    background-image: url("../assets/images/top.png");
  }

  .btn_join em {
    background-image: url("../assets/images/association.png");
  }
}

/deep/.banner_swipe {
  width: 100%;
  position: relative;

  #box {
    width: 100%;
    height: 50px;
    background: #20317f;
  }

  .marquee-box {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  #pWidth {
    width: 100%;
    height: 50px;
    padding: 0;
    margin: 0;
    line-height: 50px;
    display: flex;
    align-items: center;
    word-break: keep-all;
    white-space: nowrap;
    // overflow: hidden;
    font-family: "MicrosoftYaHei";
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 400;

    img {
      vertical-align: middle;
      margin-right: 10px;
      width: 20px;
      height: 20px;
      object-fit: contain;
    }

    ul {
      display: flex;
      align-items: center;

      li {
        margin-right: 20px;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }

  .banner {
    width: 100%;
    background: #f4f4f4;

    .container {
      display: flex;
      align-items: center;
      position: relative;
      height: 418px;

      .banner-left {
        h1 {
          font-family: SourceHanSerifCN-Heavy;
          font-size: 72px;
          color: #20317f;
          letter-spacing: 0;
          font-weight: 900;
        }

        h2 {
          font-family: SourceHanSerifCN-Heavy;
          font-size: 40px;
          color: #222222;
          letter-spacing: 0;
          font-weight: 900;
          margin-top: 4px;
        }
      }

      .swiper-right {
        width: 576px;
        position: absolute;
        bottom: -26px;
        right: 0;
        z-index: 999;

        .el-image__inner {
          border-radius: 8px;
        }

        .el-carousel__indicator--horizontal {
          padding: 10px 5px;
        }

        .el-carousel__button {
          width: 40px;
          height: 6px;
          border-radius: 1px;
          opacity: 1;
        }

        .el-carousel__indicator.is-active button {
          background-color: #20317f;
        }
      }
    }
  }

  .el-image {
    width: 100%;
    height: 100%;
  }

  .el-carousel__arrow {
    top: 45%;
    width: 50px;
    height: 100px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 0;
  }

  .el-carousel__arrow i {
    font-size: 20px;
  }

  .el-carousel__arrow--left {
    left: 0;
  }

  .el-carousel__arrow--right {
    right: 0;
  }
}

.column-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  h3 {
    font-family: "MicrosoftYaHei";
    font-size: 20px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 400;
    line-height: 26px;
    display: flex;
    align-items: center;
  }

  h3::before {
    content: "";
    width: 4px;
    height: 20px;
    background: #20317f;
    display: inline-block;
    transform: rotate(15deg);
    margin-right: 10px;
  }

  .more {
    font-family: "MicrosoftYaHei";
    font-size: 14px;
    color: #888888;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 400;
    line-height: 20px;
    display: flex;
    align-items: center;

    i {
      font-size: 20px;
    }
  }
}

.search-con-box {
  background: #ffffff;
}

.el-main {
  width: 1200px;
  margin: 0 auto;

  .search-con {
    background: #ffffff;
    border-radius: 8px;
    padding: 60px 0;
    // margin-top: -30px;
    position: relative;
    z-index: 99;
    border-bottom: 1px solid #eeeeee;

    h2 {
      font-family: "MicrosoftYaHei";
      font-size: 20px;
      color: #222222;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 26px;
      // text-align: center;
      margin-bottom: 40px;
      display: flex;
      align-items: center;

      // justify-content: center;
      b {
        font-family: "MicrosoftYaHei-Bold";
        font-size: 40px;
        color: #20317f;
        letter-spacing: 0;
        font-weight: 700;
        line-height: 52px;
        padding: 0 10px;
      }
    }

    .hot-search {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .hot-con {
        display: flex;
        align-items: center;

        h4 {
          font-family: "MicrosoftYaHei";
          font-size: 14px;
          color: #999999;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 20px;
        }

        span {
          background: #f2f2f2;
          border-radius: 4px;
          font-family: "MicrosoftYaHei";
          font-size: 14px;
          color: #222222;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 20px;
          padding: 5px 11px;
          margin-right: 5px;
        }
      }

      .more {
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #888888;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 400;
        line-height: 20px;
        display: flex;
        align-items: center;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .chats {
    padding: 60px 0;
    background: #ffffff;
    border-radius: 8px;

    .chats-info {
      display: flex;
      align-items: center;

      .total-num {
        font-family: "MicrosoftYaHei";
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 26px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex: 1;
        margin-left: 60px;

        h3 {
          padding: 20px 0;
        }

        b {
          font-family: " MicrosoftYaHei-Bold";
          font-size: 40px;
          color: #20317f;
          letter-spacing: 0;
          font-weight: 700;
          line-height: 52px;
          margin-left: 20px;
        }
      }
    }

    p {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #888888;
      letter-spacing: 0;
      text-align: justify;
      line-height: 20px;
      font-weight: 400;
      margin-bottom: 10px;
    }

    .member-num {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .member-num-item {
        overflow: hidden;
        padding: 20px;
        background: #dbdeea;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        z-index: 1000;
        transition: background 1s;
        -webkit-transition: background 1s;

        /* Safari */
        h4 {
          font-family: MicrosoftYaHei-Bold;
          font-size: 14px;
          color: #20317f;
          letter-spacing: 0;
          text-align: justify;
          font-weight: 700;
          margin-bottom: 8px;
        }

        span {
          font-family: MicrosoftYaHei-Bold;
          font-size: 36px;
          color: #20317f;
          letter-spacing: 0;
          text-align: justify;
          font-weight: 700;
          padding-bottom: 2px;
        }

        .member-num-child {
          transition: background 1s;
          -webkit-transition: background 1s;
          /* Safari */
          // display: none;
          background: #dbdeea;
          // background: #20317f;
          opacity: 0;
          position: absolute;
          top: 90px;
          left: 0;
          width: 100%;
          padding: 10px;
          margin-top: 10px;
          box-sizing: border-box;
          z-index: 999;
          border-radius: 0 0 8px 8px;

          ul {
            border-top: 1px solid rgba(255, 255, 255, 0.08);
            padding: 10px 0 0;

            li {
              font-family: MicrosoftYaHei;
              font-size: 14px;
              // color: #ffffff;
              color: #20317f;
              letter-spacing: 0;
              text-align: justify;
              font-weight: 400;
              padding: 10px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            li:hover {
              background: rgba(216, 216, 216, 0.12);
              border-radius: 4px;
            }

            li:hover::after {
              content: "";
              display: block;
              width: 16px;
              height: 16px;
              background: url("../assets/imgs/arrow-white.png") no-repeat center center;
              background-size: contain;
            }

            .two-column {
              float: left;
              width: 50%;
            }
          }
        }
      }

      .member-num-item:first-child {
        width: 161px;
      }

      .member-num-item:nth-child(2) {
        width: 426px;
      }

      .member-num-item:nth-child(3) {
        width: 174px;
      }

      .member-num-item:nth-child(4) {
        width: 254px;
      }

      .member-num-item:nth-child(5) {
        width: 130px;
      }

      .member-num-item:hover {
        background: #20317f;
        overflow: visible;

        h4 {
          color: #ffffff;
        }

        span {
          color: #ffffff;
        }

        .member-num-child {
          // display: block;
          background: #20317f;
          opacity: 1;

          li {
            color: #ffffff;
          }
        }
      }
    }
  }

  .section-news {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;

    .news {
      background: #ffffff;
      border-radius: 8px;
      padding: 20px;
      margin-top: 20px;
    }

    .section-left {
      flex: 1;

      .news-dynamic {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        .news-dynamic-left {
          position: relative;
          width: 300px;
          height: 200px;
          border-radius: 4px;
          margin-right: 20px;

          .el-image {
            width: 100%;
            height: 200px;
          }

          h3 {
            font-family: "MicrosoftYaHei";
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 19px;
            padding: 15px;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.7);

            p {
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }

            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
          }
        }

        .news-dynamic-right {
          flex: 1;

          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            h3 {
              font-family: "MicrosoftYaHei";
              font-size: 14px;
              color: #222222;
              letter-spacing: 0;
              font-weight: 400;
              line-height: 20px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }

            div {
              font-family: "MicrosoftYaHei";
              font-size: 12px;
              color: #888888;
              letter-spacing: 0;
              font-weight: 400;
              line-height: 16px;
              min-width: 75px;
              margin-left: 20px;
            }
          }

          .line {
            height: 1px;
            background: #eeeeee;
            margin: 12px 0;
          }
        }
      }

      .news-service {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;

        .news-service-item {
          position: relative;
          padding: 25px 15px 12px;
          background: #f2f2f2;
          border-radius: 4px;
          overflow: hidden;
          margin-right: 10px;
          width: 25%;
          font-size: 0;

          span {
            position: absolute;
            top: 0;
            left: 0;
            background: #0279ff;
            border-radius: 4px 0 7px 0;
            font-family: "MicrosoftYaHei";
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 16px;
            padding: 3px 10px;
          }

          h3 {
            font-family: "MicrosoftYaHei";
            font-size: 14px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 19px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
            margin-bottom: 2px;
            height: 38px;
          }

          time {
            font-family: "MicrosoftYaHei";
            font-size: 12px;
            color: #888888;
            letter-spacing: 0;
            text-align: right;
            font-weight: 400;
            line-height: 16px;
          }
        }

        .news-service-item:last-child {
          margin-right: 0;
        }
      }

      .news-class {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;

        .news-class-item {
          width: 33.3333%;
          margin-right: 10px;
          font-size: 0;

          img {
            width: 100%;
            height: 155px;
            border-radius: 4px;
            object-fit: cover;
          }

          h3 {
            font-family: "MicrosoftYaHei";
            font-size: 14px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 19px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;
            margin-top: 8px;
            margin-bottom: 2px;
          }

          time {
            font-family: "MicrosoftYaHei";
            font-size: 12px;
            color: #888888;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 16px;
          }
        }

        .news-class-item:last-child {
          margin-right: 0;
        }
      }
    }

    .section-right {
      width: 360px;
      margin-left: 20px;
      margin-top: 20px;

      /deep/.swipe_left {
        width: 100%;
        border-radius: 8px;

        .el-carousel__indicators--labels {
          bottom: 10px !important;

          .el-carousel__indicator {
            padding: 0;
            margin-right: 5px;
          }

          .el-carousel__button {
            opacity: 1;
            padding: 0;
            width: 24px;
            height: 24px;
            font-family: "MicrosoftYaHei";
            font-size: 12px;
            color: #fff;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            border-radius: 4px;
            background: #20317f;
          }

          .is-active .el-carousel__button {
            background: #ffffff;
            color: #20317f;
          }
        }

        .el-carousel__indicators--labels {
          text-align: right;
        }

        .el-image {
          width: 100%;
          height: 100%;
        }

        p {
          position: absolute;
          bottom: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.7);
          padding: 12px 15px;
          font-family: "MicrosoftYaHei";
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 19px;
          width: 100%;
        }
      }

      .news-story-list {
        margin-top: 20px;
      }

      .story-title {
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #222222;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .line {
        height: 1px;
        background: #eeeeee;
        margin: 12px 0;
      }
    }
  }
}

.swipe_item {
  width: 100%;
  height: 100%;
  position: relative;

  .el-image {
    height: 100%;
    border-radius: 8px;
  }

  .desc_info {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px;
    font-size: 18px;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0 0 8px 8px;
    width: 100%;
    box-sizing: border-box;

    h4 {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
  }
}

.events {
  position: relative;
  padding: 20px 0;
  background: #2c2d33;
  border-radius: 8px;
  margin-top: 20px;
  overflow: hidden;

  .bg {
    position: absolute;
    right: 0;
    top: 0;

    img {
      width: auto;
      height: 100%;
    }

    height: 100%;
  }

  .bg::before {
    position: absolute;
    right: 0;
    top: 0;
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(270deg,
        rgba(44, 45, 51, 0) 19%,
        #2c2d33 97%);
  }

  .title {
    margin-bottom: 5px;
    padding: 0 20px;

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
      display: flex;
      align-items: center;
    }

    h3::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 20px;
      opacity: 0.4;
      background: #ffffff;
      transform: rotate(15deg);
      margin-right: 10px;
    }

    .more {
      opacity: 0.5;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
      position: relative;
      z-index: 99;
    }
  }

  .desc {
    opacity: 0.5;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: justify;
    line-height: 20px;
    font-weight: 400;
    padding-left: 20px;
  }

  .events-swiper {
    margin-top: 20px;

    .events-swiper-item {
      width: 100%;
      height: 200px;
      border-radius: 4px;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }

      h3 {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 15px;
        width: 100%;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        opacity: 0.7;
        background: rgba(0, 0, 0, 0.7);
        box-sizing: border-box;
        // border-radius: 0px 0px 4px 4px;
      }
    }

    .time {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .circle {
        width: 6px;
        height: 6px;
        border: 3px solid rgba(255, 255, 255, 1);
        border-radius: 12px;
      }

      time {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: justify;
        line-height: 20px;
        font-weight: 400;
        margin-left: 5px;
        margin-right: 10px;
      }

      .line {
        flex: 1;
        border-top: 2px dashed rgba(255, 255, 255, 0.24);
      }
    }
  }
}

// 移动端
.m-logo {
  padding: 0 15px;

  a {
    display: flex;
    align-items: center;
    padding: 14px 0;
    border-bottom: 1px solid #e8e8e8;
  }

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    margin-right: 3px;
  }

  span {
    font-family: SourceHanSerifCN-Medium;
    font-size: 12px;
    color: #20317f;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 500;
  }
}

.m-title {
  padding: 24px 15px;
  height: 125px;
  box-sizing: border-box;
}

.m-swiper {
  padding: 0 15px;
  margin-bottom: 18px;
}

.wrapper {
  width: 100%;
  height: 100%;
}

.m-swiper .swipe_item {
  .desc_info {
    padding: 15px;
    font-size: 16px;
  }
}

.news_item {
  padding: 15px 0;
  display: flex;
  align-items: center;
  cursor: pointer;

  .el-image {
    width: 200px;
    height: 120px;
    margin-right: 26px;
  }

  .news_item_info {
    // margin-top: 8px;
    flex: 1;

    h3 {
      font-size: 22px;
      line-height: 34px;
      color: #000;
      margin-bottom: 18px;
    }

    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
    }

    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }

    .el-icon-view:before {
      margin-right: 5px;
    }
  }
}

.column-menu .grid-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 15px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  white-space: nowrap;
}

.column-menu .grid-content img {
  width: 40px;
  height: 40px;
}

.newsList {
  padding: 20px 15px;
  border-top: 10px solid #f2f2f2;
  margin-top: 18px;

  .newsList-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;

    h3 {
      font-family: "MicrosoftYaHei";
      font-size: 20px;
      color: #222222;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 26px;
      display: flex;
      align-items: center;
    }

    h3::before {
      content: "";
      width: 4px;
      height: 20px;
      background: #20317f;
      display: inline-block;
      transform: rotate(15deg);
      margin-right: 10px;
    }

    .column_title_more {
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      color: #888888;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
      line-height: 20px;
      display: flex;
      align-items: center;

      i {
        font-size: 16px;
      }
    }
  }

  .news_item {
    padding: 15px 0;
    border-bottom: 1px solid #eee;

    .el-image {
      width: 114px;
      height: 76px;
      margin-right: 10px;
      border-radius: 4px;
    }

    h3 {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #222222;
      letter-spacing: 0;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 10px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }

    .news_item_time {
      font-size: 12px;
      color: #888;
      margin-right: 10px;
    }
  }

  .el-button {
    width: 100%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin-top: 10px;
  }

  .link {
    margin-top: 20px;

    h5 {
      font-size: 18px;
      color: #414141;
      line-height: 30px;
      margin-bottom: 26px;
    }

    ul li {
      float: left;
      margin-right: 10px;
      margin-bottom: 10px;
      margin-left: 10px;
    }

    span {
      cursor: pointer;
      font-size: 16px;
      color: #666;
    }

    span:hover {
      text-decoration: underline;
      color: royalblue;
    }

    .el-image {
      width: 145px;
      height: 58px;
    }
  }
}
</style>
<style>
.pop-item {
  font-family: "MicrosoftYaHei";
  font-size: 14px;
  color: #222222;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  line-height: 19px;
}

.pop-item h3 {
  font-family: "MicrosoftYaHei-Bold";
  font-size: 16px;
  color: #20317f;
  letter-spacing: 0;
  font-weight: 700;
  line-height: 21px;
  margin-bottom: 5px;
}

.el-message-box {
  padding: 0 !important;
  width: 60% !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.el-message-box__btns {
  display: none;
}

.el-message-box__content {
  padding: 0 !important;
}

.el-message-box__message p {
  line-height: auto;
}

.el-message-box__headerbtn {
  z-index: 99 !important;
  font-size: 35px !important;
}

.el-message-box__header {
  padding: 0 !important;
}

.el-message-box__headerbtn .el-message-box__close {
  color: #fff !important;
}

.el-notification {
  padding: 0 !important;
  border: none !important;
  cursor: pointer;
}

.el-notification .el-notification__group {
  margin: 0;
}

.el-notification__group .el-notification__content {
  margin: 0;
}

.el-notification__group .el-notification__content p {
  height: 180px;
}

.el-notification__content p img {
  width: 100%;
}

.el-notification__group .el-notification__closeBtn {
  color: #fff;
  font-size: 20px;
}

.search-con-box .el-input__inner {
  height: 60px;
  line-height: 60px;
}

.search-con-box .el-input-group__append {
  width: 93px;
  text-align: center;
}

.search-con-box .el-input-group__append .el-button {
  font-size: 30px;
}

.banner-left .typed-element .typed-cursor {
  font-size: 70px;
  line-height: 66px;
  margin-left: 20px;
  color: #20317f;
}

.m-title h1 {
  font-family: SourceHanSerifCN-Heavy;
  font-size: 32px;
  color: #20317f;
  letter-spacing: 0;
  font-weight: 900;
}

.m-title h2 {
  font-family: SourceHanSerifCN-Heavy;
  font-size: 20px;
  color: #222222;
  letter-spacing: 0;
  font-weight: 900;
  margin-top: 4px;
}

.m-title .typed-element .typed-cursor {
  font-size: 30px;
  line-height: 36px;
  margin-left: 10px;
  color: #20317f;
}

.m-swiper .el-carousel__button {
  width: 27px;
  height: 3px;
  border-radius: 1px;
  opacity: 1;
}

.m-swiper .el-carousel__indicator--horizontal {
  padding: 11px 3px;
}

.m-swiper .el-carousel__indicator:hover button {
  opacity: 1;
}

.m-swiper .el-carousel__indicator.is-active button {
  background-color: #20317f;
}

@media screen and (max-width: 768px) {
  .el-message-box {
    width: 90% !important;
  }

  .el-message-box__headerbtn {
    font-size: 28px !important;
    top: 0px !important;
    right: 8px !important;
  }
}
</style>